import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { UserContext, type UserContextType } from "@/context/user";
import { getCookie } from "@/lib/utils";



export const UserProvider = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = React.useState(null);
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [loginProvider, setLoginProviderState] = React.useState(
    localStorage.getItem("loginProvider") || "github",
  );

  const setLoginProvider = (provider: string) => {
    setLoginProviderState(provider);
    localStorage.setItem("loginProvider", provider);
  };

  const logout = async (
    callback: (isLoggedOut: boolean) => void = () => {},
  ) => {
    const res = await fetch(
      `${import.meta.env.VITE_PUBLIC_API_ENDPOINT}/auth/${loginProvider}/logout`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: getCookie("session") || "",
        },
        credentials: "include",
      },
    );
    if (res.ok) {
      setIsAuthenticated(false);
      setUser(null);
      if (typeof callback === "function") {
        callback(true);
      }
      navigate("/login");
    } else {
      if (typeof callback === "function") {
        callback(false);
      }
    }
  };

  const fetchProfile = async () => {
    try {
      const res = await fetch(
        import.meta.env.VITE_PUBLIC_API_ENDPOINT + "/profile",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: getCookie("session") || "",
          },
          credentials: "include",
        },
      );
      if (res.ok) {
        const resJson = await res.json();
        setIsAuthenticated(Number(res.status) === 200 ? true : false);
        setUser(resJson?.data?.user);
        // navigate("/");
      } else if (res.status === 401) {
        if (location.pathname !== "/login") {
          navigate("/login");
        }
      }
    } catch (error) {
      console.log(error);
      setIsAuthenticated(false);
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    fetchProfile();
  }, []);

  const contextValue: UserContextType = {
    isAuthenticated,
    isLoading,
    user,
    logout,
    fetchProfile,
    loginProvider,
    setLoginProvider,
  };

  return (
    <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
  );
};
